import React, { useEffect } from 'react';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      <section className="bg-gradient-to-br from-primary-700 to-primary-800 text-white py-12">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold mb-2">TERMS OF SERVICE</h1>
            <p className="opacity-90">Last updated August 25, 2025</p>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
            <div className="p-6 md:p-10 prose prose-gray max-w-none">
              <h2>TABLE OF CONTENTS</h2>
              <ol>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-1">1. AGREEMENT TO TERMS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-2">2. INTELLECTUAL PROPERTY RIGHTS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-3">3. USER REPRESENTATIONS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-4">4. USER REGISTRATION</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-5">5. FEES AND PAYMENT</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-6">6. FREE TRIAL</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-7">7. CANCELLATION</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-8">8. PROHIBITED ACTIVITIES</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-9">9. USER GENERATED CONTRIBUTIONS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-10">10. CONTRIBUTION LICENSE</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-11">11. SUBMISSIONS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-12">12. U.S. GOVERNMENT RIGHTS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-13">13. SITE MANAGEMENT</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-14">14. PRIVACY POLICY</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-15">15. COPYRIGHT INFRINGEMENTS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-16">16. TERM AND TERMINATION</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-17">17. MODIFICATIONS AND INTERRUPTIONS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-18">18. GOVERNING LAW</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-19">19. DISPUTE RESOLUTION</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-20">20. CORRECTIONS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-21">21. DISCLAIMER</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-22">22. LIMITATIONS OF LIABILITY</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-23">23. INDEMNIFICATION</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-24">24. USER DATA</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-25">25. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-26">26. CALIFORNIA USERS AND RESIDENTS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-27">27. MISCELLANEOUS</a></li>
                <li><a className="text-blue-600 hover:text-blue-700 underline" href="#t-28">28. CONTACT US</a></li>
              </ol>

              <h3 id="t-1">1. AGREEMENT TO TERMS</h3>
              <p>
                These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and Golf Marshal, LLC ("Company", "we", "us", or "our"), concerning your access to and use of the https://www.getgolfmarshal.com website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the "Site"). We are registered in Missouri, United States and have our registered office at __________, Sainte Genevieve, MO 63670. You agree that by accessing the Site, you have read, understood, and agree to be bound by all of these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.
              </p>
              <p>
                Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms of Use at any time and for any reason. We will alert you about any changes by updating the “Last updated” date of these Terms of Use. Please ensure that you check the applicable Terms every time you use our Site so that you understand which Terms apply. Your continued use of the Site after the posting of revised Terms means you accept and agree to the changes.
              </p>
              <p>
                The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws.
              </p>
              <p>
                The Site is not tailored to comply with industry-specific regulations (HIPAA, FISMA, etc.); you may not use the Site in a way that would violate GLBA.
              </p>
              <p>
                The Site is intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to use or register for the Site.
              </p>

              <h3 id="t-2">2. INTELLECTUAL PROPERTY RIGHTS</h3>
              <p>
                Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us and are protected by intellectual property laws. The Content and Marks are provided “AS IS” for your information and personal use only. Except as expressly provided in these Terms, no part of the Site and no Content or Marks may be used for any commercial purpose without our express prior written permission.
              </p>
              <p>
                Provided that you are eligible to use the Site, you are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use. We reserve all rights not expressly granted.
              </p>

              <h3 id="t-3">3. USER REPRESENTATIONS</h3>
              <p>
                By using the Site, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information; (3) you have the legal capacity and you agree to comply with these Terms; (4) you are not a minor; (5) you will not access the Site through automated or non-human means; (6) you will not use the Site for any illegal or unauthorized purpose; and (7) your use of the Site will not violate any applicable law or regulation.
              </p>

              <h3 id="t-4">4. USER REGISTRATION</h3>
              <p>
                You may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine it is inappropriate, obscene, or otherwise objectionable.
              </p>

              <h3 id="t-5">5. FEES AND PAYMENT</h3>
              <p>
                We accept Visa, Mastercard, American Express, Discover, and PayPal. You may be required to purchase or pay a fee to access some services. You agree to provide current, complete, and accurate purchase and account information for all purchases and to promptly update account and payment information as needed. We bill you through an online billing account. Sales tax may be added. We may change prices at any time. All payments shall be in U.S. dollars. If your purchase is subject to recurring charges, you consent to recurring billing until you cancel.
              </p>
              <p>
                We reserve the right to correct any errors in pricing and to refuse any order placed through the Site.
              </p>

              <h3 id="t-6">6. FREE TRIAL</h3>
              <p>
                We offer a 60-day free trial to new users who register with the Site. The account will be charged according to the chosen subscription at the end of the free trial.
              </p>

              <h3 id="t-7">7. CANCELLATION</h3>
              <p>
                You can cancel your subscription at any time by contacting us. Your cancellation will take effect at the end of the current paid term. If you are unsatisfied with our services, please email us at support@getgolfmarshal.com or call us at (573) 326-9239.
              </p>

              <h3 id="t-8">8. PROHIBITED ACTIVITIES</h3>
              <p>
                You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those endorsed or approved by us. Examples include prohibitions on scraping, security circumvention, harassment, unauthorized framing, malware distribution, automated usage, reverse engineering, and other activities described here.
              </p>

              <h3 id="t-9">9. USER GENERATED CONTRIBUTIONS</h3>
              <p>
                The Site may invite Contributions (e.g., text, images, feedback). Contributions may be viewable by other users and third-party websites and are treated as non-confidential and non-proprietary. You represent you have all rights necessary and that your Contributions comply with applicable laws and these Terms.
              </p>

              <h3 id="t-10">10. CONTRIBUTION LICENSE</h3>
              <p>
                By posting Contributions, you grant us a worldwide, royalty-free, transferable, sublicensable, perpetual license to use, host, reproduce, publish, display, distribute, and create derivative works from your Contributions for any lawful purpose. You waive moral rights to the extent permitted by law.
              </p>

              <h3 id="t-11">11. SUBMISSIONS</h3>
              <p>
                Any Submissions (ideas, suggestions, proposals) you send are non-confidential and become our sole property. We may use and disseminate them without compensation.
              </p>

              <h3 id="t-12">12. U.S. GOVERNMENT RIGHTS</h3>
              <p>
                Our services are “commercial items” under FAR 2.101 and are provided subject to the applicable FAR/DFARS clauses referenced herein.
              </p>

              <h3 id="t-13">13. SITE MANAGEMENT</h3>
              <p>
                We may monitor the Site, take legal action for violations, restrict access, remove burdensome content, and otherwise manage the Site to protect our rights and ensure proper functioning.
              </p>

              <h3 id="t-14">14. PRIVACY POLICY</h3>
              <p>
                We care about data privacy and security. Please review our <a className="text-blue-600 hover:text-blue-700 underline" href="/privacy">Privacy Policy</a>. By using the Site, you agree to be bound by our Privacy Policy. The Site is hosted in the United States.
              </p>

              <h3 id="t-15">15. COPYRIGHT INFRINGEMENTS</h3>
              <p>
                If you believe any material on the Site infringes your copyright, notify us using the contact information provided below. You may be liable for damages if you materially misrepresent that content infringes your copyright.
              </p>

              <h3 id="t-16">16. TERM AND TERMINATION</h3>
              <p>
                These Terms remain in effect while you use the Site. We may deny access to the Site to any person for any reason, including violations of these Terms, and may terminate accounts at any time without notice.
              </p>

              <h3 id="t-17">17. MODIFICATIONS AND INTERRUPTIONS</h3>
              <p>
                We reserve the right to change or discontinue the Site at any time without notice and are not liable for any modification, price change, suspension, or discontinuance. We do not guarantee uninterrupted availability.
              </p>

              <h3 id="t-18">18. GOVERNING LAW</h3>
              <p>
                These Terms and your use of the Site are governed by the laws of the State of Missouri, without regard to conflict of law principles.
              </p>

              <h3 id="t-19">19. DISPUTE RESOLUTION</h3>
              <p>
                <strong>Informal Negotiations.</strong> The Parties agree to attempt to resolve Disputes informally for at least thirty (30) days before initiating arbitration.
              </p>
              <p>
                <strong>Binding Arbitration.</strong> If unresolved, Disputes will be finally resolved by binding arbitration under the AAA Commercial Rules (and, where applicable, the AAA Consumer Rules). Venue shall be Sainte Genevieve, Missouri, unless otherwise required by applicable rules or law. Certain Disputes (e.g., IP enforcement) are excluded. If any portion is unenforceable, the remainder shall be decided by a court of competent jurisdiction in Sainte Genevieve, Missouri.
              </p>
              <p>
                <strong>Restrictions.</strong> Arbitration shall be limited to the Parties individually; class actions are not permitted.
              </p>

              <h3 id="t-20">20. CORRECTIONS</h3>
              <p>
                Information on the Site may contain errors or omissions. We reserve the right to correct and update content at any time without notice.
              </p>

              <h3 id="t-21">21. DISCLAIMER</h3>
              <p>
                THE SITE IS PROVIDED ON AN “AS-IS” AND “AS-AVAILABLE” BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED.
              </p>

              <h3 id="t-22">22. LIMITATIONS OF LIABILITY</h3>
              <p>
                IN NO EVENT WILL WE BE LIABLE TO YOU FOR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID, IF ANY, BY YOU TO US DURING THE SIX (6) MONTHS PRIOR TO THE CLAIM.
              </p>

              <h3 id="t-23">23. INDEMNIFICATION</h3>
              <p>
                You agree to defend, indemnify, and hold us harmless from any claims arising out of (1) your Contributions; (2) your use of the Site; (3) breach of these Terms; (4) your violation of third-party rights; or (5) harmful acts toward other users.
              </p>

              <h3 id="t-24">24. USER DATA</h3>
              <p>
                We may maintain certain data transmitted to the Site. You are solely responsible for all data you transmit or that relates to your activity on the Site.
              </p>

              <h3 id="t-25">25. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</h3>
              <p>
                You consent to electronic communications and agree that all agreements, notices, disclosures, and other communications we provide electronically satisfy legal requirements.
              </p>

              <h3 id="t-26">26. CALIFORNIA USERS AND RESIDENTS</h3>
              <p>
                If any complaint with us is not satisfactorily resolved, you may contact the California Department of Consumer Affairs at 1625 North Market Blvd., Suite N 112, Sacramento, CA 95834 or (800) 952-5210.
              </p>

              <h3 id="t-27">27. MISCELLANEOUS</h3>
              <p>
                These Terms and any policies posted by us constitute the entire agreement. If any provision is unlawful or unenforceable, it is severed without affecting the remaining provisions.
              </p>

              <h3 id="t-28">28. CONTACT US</h3>
              <p>
                If you have questions or comments about this notice, you may email us at
                {' '}
                <a className="text-blue-600 hover:text-blue-700 underline" href="mailto:support@getgolfmarshal.com">support@getgolfmarshal.com</a>.
              </p>
              <p>Golf Marshal, LLC</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;


